































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Product, VariantColor } from '@/models/Product';
import { DoorFamily } from '@/models/DoorFamily';
import { websiteText } from '@/mixins/websiteTexts';

@Component
export default class DoorFamilyList extends Vue {
    @Prop()
    protected categories!: DoorFamily[];

    constructor() {
        super();
        //console.log(this.categories);

        // this.categories.forEach(cat => {
        //     var colorList = cat.Name + ' (' + cat.ColorList.length + '): ';
        //     cat.ColorList.forEach(c => {
        //         colorList = colorList + c.Name + ', ';
        //     });

        //     console.log(colorList);

        // });

        // @ts-ignore
    }
}
